<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="language.id === null">{{ 'NEWLANGUAGE' | translate }}</span>
            <span *ngIf="language.id !== null">{{ 'EDITLANGUAGE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="languageForm" id="languageForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="languageForm" >
            <input type="hidden" name="id" id="languageId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="languageName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="languageName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="languageForm.controls['name'].invalid && (languageForm.controls['name'].dirty || languageForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="languageForm.controls['name'].errors !== null">
                  <div *ngIf="languageForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-language"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="languageLocale" formControlName="locale" type="text" pInputText [required]="true"> 
                      <label for="languageLocale" class="req">{{ 'LOCALE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="languageForm.controls['locale'].invalid && (languageForm.controls['locale'].dirty || languageForm.controls['locale'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="languageForm.controls['locale'].errors !== null">
                  <div *ngIf="languageForm.controls['locale'].errors.required">
                   {{ 'LOCALEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-shortcode"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="languageCode" formControlName="code" type="text" pInputText [required]="true"> 
                      <label for="languageCode" class="req">{{ 'CODE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="languageForm.controls['code'].invalid && (languageForm.controls['code'].dirty || languageForm.controls['code'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="languageForm.controls['code'].errors !== null">
                  <div *ngIf="languageForm.controls['code'].errors.required">
                   {{ 'CODEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="languagePreferred" formControlName="preferred" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="languagePreferred" class="p-d-inline-block p-ml-2 req">{{ 'PREFERRED' | translate }}</label>
                </div>
                <div *ngIf="languageForm.controls['preferred'].invalid && (languageForm.controls['preferred'].dirty || languageForm.controls['preferred'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="languageForm.controls['preferred'].errors !== null">
                  <div *ngIf="languageForm.controls['preferred'].errors.required">
                   {{ 'PREFERREDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKLANGUAGES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="language.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!languageForm.valid || disableSubmit"> <!--  [disabled]="languageForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!languageForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

